import {
  FileUploadProps,
  FileUploadViewMultiline,
  FileUploadViewOneline,
} from 'common/components/file-upload';
import { Caption, Typography } from 'fronton-react';
import React from 'react';
import { Breakpoint } from 'types/utils';
import { useTranslation } from 'react-i18next';
import { Styles } from '../styles';

export type UploadPhotosPartProps = {
  breakpoint: Breakpoint;
  hasError?: boolean;
} & Omit<FileUploadProps, 'inputProps'>;

export const UploadPhotosPart: React.FC<UploadPhotosPartProps> = ({
  breakpoint,
  picCovers,
  onRetryClick,
  onRemoveClick,
  onFileSelectionClick,
  onFilesSelect,
  hasError,
}) => {
  const { t } = useTranslation();
  const FileUploadWidget = breakpoint === 'mobile' ? FileUploadViewOneline : FileUploadViewMultiline;

  const inputProps = React.useMemo(
    () => ({
      accept: 'image/*',
      'data-qa': 'file-upload-input_mf-pdp',
    }),
    [],
  );

  return (
    <div className={Styles.partPhotoContainer} data-qa="form-part-photo-wrapper">
      <Typography variant="m" size="subtitle" as="h3" className={Styles.formPartHeader}>
        {t('reviews.form.photo.title')}
      </Typography>
      <FileUploadWidget
        inputProps={inputProps}
        picCovers={picCovers}
        onRemoveClick={onRemoveClick}
        onRetryClick={onRetryClick}
        onFileSelectionClick={onFileSelectionClick}
        onFilesSelect={onFilesSelect}
        data-qa="review-form-file-upload_mf-pdp"
      />
      {hasError && (
        <Caption
          className={Styles.formPartPhotoStatus}
          error
          message={t('reviews.form.validation-errors.photo-processing')}
        />
      )}
    </div>
  );
};
